module.exports = __webpack_public_path__ + "media/images/brand/logo-primary-2026-e7025f5574744e6241a40ff90490cfa2.svg";